import React from 'react';
import { formatValue } from '../../utils';

export default ({epf, socso, eis}) => (
    <div className='row'>
        <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='employer-contribution'>
                <div className='label'>EPF</div>
                <div className='value'>RM {formatValue(epf || 0)}</div>
            </div>
        </div>
        <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='employer-contribution'>
                <div className='label'>SOCSO</div>
                <div className='value'>RM {formatValue(socso || 0)}</div>
            </div>
        </div>
        <div className='col-sm-12 col-md-6 col-xl-4'>
            <div className='employer-contribution'>
                <div className='label'>EIS</div>
                <div className='value'>RM {formatValue(eis || 0)}</div>
            </div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/Calculator/Contributions.js